import { createAction } from 'redux-actions'
import { START_FETCHING, FETCH_MENU_ITEMS_SUCCESS, FETCH_MENU_ITEMS_FAILED } from '../consts/menuItems'

export const startFetchingMenuItems = createAction(START_FETCHING)
export const fetchMenuItemsSuccess = createAction(FETCH_MENU_ITEMS_SUCCESS)
export const fetchMenuItemsFailed = createAction(FETCH_MENU_ITEMS_FAILED)
